import { Box, Text } from '@wix/design-system';
import {
  StylesDerivedNativeActions,
  StylesDerivedNativeActionNames,
} from '@wix/editor-platform-host-integration-apis';
import React from 'react';
import { useTranslation } from '../../../useTranslation';

const ACTION_NAME_TITLE_MAPPER: Partial<
  Record<StylesDerivedNativeActionNames, string>
> = {
  [StylesDerivedNativeActions.borderStyles]: 'globalDesign.border.mainHeader',
  [StylesDerivedNativeActions.cornerStyles]: 'globalDesign.corner.mainHeader',
  [StylesDerivedNativeActions.globalColorsStyles]:
    'action_bar.global_colors.mini_panel.header',
  [StylesDerivedNativeActions.shadowStyles]: 'globalDesign.shadow.mainHeader',
  [StylesDerivedNativeActions.textStyles]: 'globalDesign.text.mainHeader',
  [StylesDerivedNativeActions.strokeStyles]: 'globalDesign.border.mainHeader',
  [StylesDerivedNativeActions.filterStyles]: 'globalDesign.shadow.mainHeader',
};

const StyleLobbyHeader = ({
  actionName,
  stylesCount,
}: {
  actionName: StylesDerivedNativeActionNames;
  stylesCount: number;
}) => {
  const [t] = useTranslation();
  const title = ACTION_NAME_TITLE_MAPPER[actionName];

  if (!title) {
    return null;
  }

  return (
    <Text size="small" ellipsis weight="bold">
      {t(title, { number: stylesCount })}
    </Text>
  );
};

export default StyleLobbyHeader;
